/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { fetchQuizzes, fetchQuiz, updateQuiz } from './action';

export const quizSlice = createSlice({
  name: 'quiz',
  initialState: {
    quizzes: [],
    quiz: null,
    isLoading: false,
    error: null,
  },
  reducers: {
    clearQuizzes: (state) => {
      state.quizzes = [];
    },
    clearQuiz: (state) => {
      state.quiz = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchQuizzes.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchQuizzes.fulfilled, (state, action) => {
        state.quizzes = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchQuizzes.rejected, (state, action) => {
        state.error = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchQuiz.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchQuiz.fulfilled, (state, action) => {
        state.quiz = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchQuiz.rejected, (state, action) => {
        state.error = action.payload;
        state.isLoading = false;
      })
      .addCase(updateQuiz.fulfilled, (state, action) => {
        state.quiz = action.payload;
      });
  },
});

export const { clearQuizzes, clearQuiz } = quizSlice.actions;

export default quizSlice.reducer;
